import React from "react";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";
import "./RelatorioGestaoMudancasPrint.css";

function valor(conteudo, fallback = "-") {
  const texto = String(conteudo ?? "").trim();
  return texto || fallback;
}

function formatarDataBR(data) {
  if (!data) return "-";
  const [ano, mes, dia] = String(data).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : String(data);
}

function formatarResponsavelVerificacao(registro) {
  const nome = String(registro?.responsavelVerificacao || "").trim();
  const cargo = String(registro?.cargoVerificacao || "").trim();
  if (!nome) return "-";
  return cargo ? `${nome} (${cargo})` : nome;
}

function Marcacao({ marcada, children }) {
  return (
    <span className="opcao">
      <span className="caixa">{marcada ? "☒" : "☐"}</span> {children}
    </span>
  );
}

function imprimir(codigo) {
  const nome = String(codigo || "REGISTRO-GESTAO-MUDANCAS").trim();
  document.title = nome;
  window.print();
}

export default function RelatorioGestaoMudancasPrint({ registro, onVoltar }) {
  useNomeArquivoPdf(registro?.codigo || "REGISTRO-GESTAO-MUDANCAS");

  if (!registro) return null;

  const motivos = registro.motivos || {};
  const recursos = registro.recursos || {};

  return (
    <div className="relatorio-gestao-mudancas-print">
      <div className="acoes-print">
        {onVoltar && <button onClick={onVoltar}>Voltar</button>}
        <button className="btn-imprimir" onClick={() => imprimir(registro.codigo)}>
          Imprimir
        </button>
      </div>

      <div className="pagina">
        <table className="cabecalho">
          <tbody>
            <tr>
              <td rowSpan="3" className="logo-cell">
                <LogoRelatorio alt="Logo" className="logo" />
              </td>
              <td rowSpan="3" className="titulo">
                <div>SISTEMA DE GESTÃO DA QUALIDADE</div>
                <strong>REGISTRO DE GESTÃO DE MUDANÇAS</strong>
              </td>
              <td>RQ 1.7</td>
            </tr>
            <tr>
              <td>Revisão 01</td>
            </tr>
            <tr>
              <td>16/01/2026</td>
            </tr>
          </tbody>
        </table>

        <div className="secao">1. Identificação da Mudança</div>
        <table className="quadro identificacao-mudanca">
          <tbody>
            <tr>
              <td>
                <div>Solicitante:</div>
                <div className="valor">{valor(registro.solicitante)}</div>
              </td>
              <td className="col-data">
                <div>Data da Solicitação:</div>
                <div className="valor centralizado">
                  {formatarDataBR(registro.dataSolicitacao)}
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="2">
                <div>Área Impactada:</div>
                <div className="valor">{valor(registro.areaImpactada)}</div>
              </td>
            </tr>
            <tr>
              <td colSpan="2">
                <div>Descrição da Mudança:</div>
                <div className="valor texto-longo">{valor(registro.descricaoMudanca)}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div className="secao">2. Motivo da Mudança</div>
        <div className="bloco opcoes-grid">
          <Marcacao marcada={motivos.melhoriaProcesso}>Melhoria de processo</Marcacao>
          <Marcacao marcada={motivos.exigenciaNormativa}>Exigência normativa</Marcacao>
          <Marcacao marcada={motivos.mudancaTecnologica}>Mudança tecnológica</Marcacao>
          <Marcacao marcada={motivos.resultadoAuditoria}>Resultado de auditoria</Marcacao>
          <Marcacao marcada={motivos.decisaoDirecao}>Decisão da direção</Marcacao>
          <span />
          <div className="outro">
            <Marcacao marcada={motivos.outro}>Outro:</Marcacao>
            <span className="linha-preenchimento">{valor(motivos.outroDescricao, "")}</span>
          </div>
        </div>

        <div className="secao">3. Avaliação da Mudança</div>
        <div className="campo-relatorio">
          <div>Propósito da mudança e possíveis consequências:</div>
          <div className="valor texto-longo">{valor(registro.propositoConsequencias)}</div>
        </div>
        <div className="campo-relatorio">
          <div>Impactos na integridade do Sistema de Gestão da Qualidade:</div>
          <div className="valor texto-longo">{valor(registro.impactosIntegridade)}</div>
        </div>
        <div className="campo-relatorio">
          <div>Recursos necessários para implementação:</div>
          <div className="opcoes-grid recursos-grid">
            <Marcacao marcada={recursos.treinamento}>Treinamento</Marcacao>
            <Marcacao marcada={recursos.sistema}>Sistema</Marcacao>
            <Marcacao marcada={recursos.equipamento}>Equipamento</Marcacao>
            <Marcacao marcada={recursos.atualizacaoDocumental}>
              Atualização documental
            </Marcacao>
            <Marcacao marcada={recursos.infraestrutura}>Infraestrutura</Marcacao>
          </div>
        </div>

        <div className="secao">4. Responsabilidades</div>
        <div className="campo-relatorio compacto">
          <div>Responsável pela implementação:</div>
          <div className="valor">{valor(registro.responsavelImplementacao)}</div>
        </div>
        <div className="campo-relatorio compacto">
          <div>Responsável pelo acompanhamento:</div>
          <div className="valor">{valor(registro.responsaveisAcompanhamento)}</div>
        </div>

        <div className="secao">5. Aprovação da Direção</div>
        <table className="quadro aprovacao">
          <tbody>
            <tr>
              <td>
                <div>Nome:</div>
                <div className="valor">{valor(registro.aprovacaoNome)}</div>
              </td>
              <td className="col-data">
                <div>Data:</div>
                <div className="valor centralizado">
                  {formatarDataBR(registro.aprovacaoData)}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="assinatura">
          <div className="linha-assinatura" />
          <span>Assinatura</span>
        </div>

        <div className="secao">6. Implementação</div>
        <table className="quadro implementacao">
          <tbody>
            <tr>
              <td>
                <div>Data de início:</div>
                <div className="valor centralizado">{formatarDataBR(registro.dataInicio)}</div>
              </td>
              <td>
                <div>Data de conclusão:</div>
                <div className="valor centralizado">
                  {registro.dataConclusao
                    ? formatarDataBR(registro.dataConclusao)
                    : valor(registro.statusImplementacao, "Em andamento")}
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div className="secao">7. Verificação de Eficácia</div>
        <div className="campo-relatorio compacto eficacia">
          <span>A mudança atingiu o resultado esperado?</span>
          <Marcacao marcada={registro.eficaciaResultado === "sim"}>Sim</Marcacao>
          <Marcacao marcada={registro.eficaciaResultado === "nao"}>Não</Marcacao>
        </div>
        <div className="campo-relatorio">
          <div>Descrição da verificação:</div>
          <div className="valor texto-longo">{valor(registro.descricaoVerificacao)}</div>
        </div>
        <table className="quadro verificacao">
          <tbody>
            <tr>
              <td>
                <div>Responsável pela verificação:</div>
                <div className="valor centralizado">
                  {formatarResponsavelVerificacao(registro)}
                </div>
              </td>
              <td className="col-data">
                <div>Data:</div>
                <div className="valor centralizado">
                  {formatarDataBR(registro.dataVerificacao)}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
